export class ManagementRepository {
  constructor(api) {
    this.api = api
  }
  async save(managementValues) {
    const maxInsertsPerLoop = 50;
    const itemsLength = managementValues && managementValues.length || 0;
    const neededLoops = Math.ceil(itemsLength / maxInsertsPerLoop);
    const loopsArr = [...Array(neededLoops).keys()];

    let resp = [];

    for await (let i of loopsArr.keys()) {
      let values=``;
      const start = i * maxInsertsPerLoop;
      const end = start + maxInsertsPerLoop - 1;

      const managValuesSliced = managementValues.slice(start, end + 1);

      managValuesSliced.forEach((row, index, rows) => {
        values += `
        (${row.ID_SECTOR},
        ${row.ID_FARM},
        ${row.ID_DAP},
        ${row.WATER_DISPONIBILITY},
        '${row.TIME}',
        ${row.PLANT_OCCUPANCY_SPACE},
        ${row.KL_FACTOR},
        ${row.VOLUME},
        ${row.RAINFALL},
        ${row.RAINFALL_INPUT},
        ${row.FLOW_AVG},
        ${row.MAX_STORAGE},
        ${row.ETC},
        ${row.KS},
        ${row.ETR},
        ${row.ETR_PREDICTION},
        ${row.ET0},
        ${row.ET0_PREDICTION},
        ${row.FINAL_STORAGE},
        ${row.EXCESS},
        ${row.NEGATIVE_ACCUMULATED},
        ${row.INITIAL_STORAGE || 0 },
        ${row.BLADE_SUGGESTION},
        ${row.IRRIGATED_BLADE},
        ${row.IRRIGATION_TIME_FLOW},
        ${row.VOLUME_INPUT},
        ${row.IRRIGATION_TIME_APP_RATE})${index === rows.length - 1 ? "" : ","}`
      });

      const raw = `
        INSERT INTO CROP.MANAGEMENT(
          ID_SECTOR,
          ID_FARM,
          ID_DAP,
          WATER_DISPONIBILITY,
          TIME,
          PLANT_OCCUPANCY_SPACE,
          KL_FACTOR,
          VOLUME,
          RAINFALL,
          RAINFALL_INPUT,
          FLOW_AVG,
          MAX_STORAGE,
          ETC,
          KS,
          ETR,
          ETR_PREDICTION,
          ET0,
          ET0_PREDICTION,
          FINAL_STORAGE,
          EXCESS,
          NEGATIVE_ACCUMULATED,
          INITIAL_STORAGE,
          BLADE_SUGGESTION,
          IRRIGATED_BLADE,
          IRRIGATION_TIME_FLOW,
          VOLUME_INPUT,
          IRRIGATION_TIME_APP_RATE
        )VALUES${values};
      `

      resp = await this.api.sql({
        data: {
          sql: raw
        }
      })
    }

    return resp;
  }

  async checkIfEmpty(ID_SECTOR) {
    const raw = `SELECT EXISTS (SELECT * FROM CROP.MANAGEMENT WHERE ID_SECTOR = ${ID_SECTOR}) as isExists;`;

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if (resp.length && resp[0].length) {
      let result = resp[0][0]
      return 'isExists' in result ? result.isExists : 0;
    }
    return;
  }

  async deleteByIdSector(ID_SECTOR){
    const raw=`
      DELETE FROM CROP.MANAGEMENT
      WHERE ID_SECTOR = ${ID_SECTOR};
    `

    const resp=await this.api.sql({
      data: {
        sql: raw
      }
    })

    return resp
  }

  async deleteByIdSectorAndInterval(ID_SECTOR,START,END){
    const raw=`
      DELETE FROM CROP.MANAGEMENT
      WHERE ID_SECTOR = ${ID_SECTOR}
      AND TIME BETWEEN '${START}' AND '${END}';
    `

    const resp=await this.api.sql({
      data: {
        sql: raw
      }
    })

    return resp
  }

  async deleteByIdSectorAndTime(ID_SECTOR,TIME){
    const raw=`
      DELETE FROM CROP.MANAGEMENT
      WHERE ID_SECTOR = ${ID_SECTOR}
      AND TIME > '${TIME}';`

    const resp=await this.api.sql({
      data: {
        sql: raw
      }
    })

    return resp
  }

  async getByIdSector(ID_SECTOR){
    const raw=`
      SELECT
        MANAGEMENT.*,
        FARMS_DAP.AVAILABILITY,
        FARMS_DAP.KC
      FROM CROP.MANAGEMENT MANAGEMENT
      LEFT JOIN CROP.FARMS_DAP FARMS_DAP
      ON FARMS_DAP.ID = (
        SELECT ID FROM CROP.FARMS_DAP
        WHERE ID_FARM = MANAGEMENT.ID_FARM
          AND DAP <= MANAGEMENT.ID_DAP
        ORDER BY DAP DESC
        LIMIT 1
      )
      LEFT JOIN CROP.CAD_SECTOR CROP_SECTOR
      ON CROP_SECTOR.ID_SECTOR = MANAGEMENT.ID_SECTOR
      WHERE (
        MANAGEMENT.ID_SECTOR = ${ID_SECTOR}
        AND TIME <= DATE_ADD(NOW(), INTERVAL -1 DAY)
        AND IF(CROP_SECTOR.DATE_CROP = '', TRUE, TIME <= CROP_SECTOR.DATE_CROP)
      )
      ORDER BY TIME ASC;
    `;

    const resp=await this.api.sql({
      data: {
        sql: raw
      }
    })

    // resp é [rows, fields] quando /sql roda; é [] quando o endpoint nega (userPermission != 1).
    // Retorna [] (não null) para o consumidor poder .map com segurança — é uma lista, não um item.
    return resp.length ? resp[0] : []
  }

  async getLastRegisterFromManagementByIdSector(ID_SECTOR){
    const raw=`
      SELECT * FROM CROP.MANAGEMENT
      WHERE ID_SECTOR = ${ID_SECTOR}
      ORDER BY TIME DESC
      LIMIT 1;
    `

    const resp=await this.api.sql({
      data: {
        sql: raw
      }
    })

    if(resp.length && resp[0].length){
      return resp[0][0]

    }
    return

  }

  async getManagementByIdSectorAndInterval(ID_SECTOR,START,END){
    let raw = `
      SELECT EXISTS (
        SELECT ID,TIME FROM CROP.MANAGEMENT
        WHERE ID_SECTOR = ${ID_SECTOR}
        AND TIME BETWEEN '${START}' AND '${END}'
        ORDER BY TIME ASC
      ) AS HAS_MANAGEMENT
    `;

    const management = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if (management.length && management[0].length) {
      const result = management[0][0]
      return 'HAS_MANAGEMENT' in result ? result.HAS_MANAGEMENT : 0;
    }
    return 0


  }

  async getRainfallByIdSector(ID_SECTOR){
    const raw = `
      SELECT TIME,RAINFALL_INPUT  FROM CROP.MANAGEMENT
      WHERE ID_SECTOR = ${ID_SECTOR}
      ORDER BY TIME
    `

    const result = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if (result.length && result[0].length) {
      //Convert to DOMAIN
      const rainfall_inputs=result[0].map(raw=>{
        const {TIME,RAINFALL_INPUT}=raw

        return {
          TIME,
          VALUE:RAINFALL_INPUT
        }

      })

      return rainfall_inputs
    }

  }

}
